/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_DataLayer_DataLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/DataLayer/DataLayer */ "./resources/scripts/components/DataLayer/DataLayer.ts");
/* harmony import */ var _scripts_components_GeoPopout_GeoPopout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/GeoPopout/GeoPopout */ "./resources/scripts/components/GeoPopout/GeoPopout.ts");



customElements.define('geo-popout', _scripts_components_GeoPopout_GeoPopout__WEBPACK_IMPORTED_MODULE_2__["default"]);
var dataLayer = new _scripts_components_DataLayer_DataLayer__WEBPACK_IMPORTED_MODULE_1__["default"]();
dataLayer.init();
var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
consent.init();
function styleKlaviyoModalOnOpen() {
  document.querySelectorAll('.klaviyo-bis-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTimeout(function () {
        var iframe = document.querySelector('#klaviyo-bis-iframe');
        if (!iframe) return;
        var iframeDoc = iframe.contentDocument;
        if (!iframeDoc) return;
        var container = iframeDoc.getElementById('container');
        var content = iframeDoc.querySelector('#container p');
        var modal = iframeDoc.querySelector('#klaviyo-bis-modal');
        var newsletter = iframeDoc.querySelector('#newsletter_subscription p');
        var label = iframeDoc.querySelector('#container label');
        var button = iframeDoc.querySelector('.btn');
        var closeButton = iframeDoc.querySelector('.close');
        var title = iframeDoc.querySelector('.modal-title');
        var emailInput = iframeDoc.querySelector('#email');
        var variantInput = iframeDoc.querySelector('#variants');
        if (modal) {
          modal.style.top = '15%';
          modal.style.position = 'relative';
        }
        if (newsletter) newsletter.style.display = 'flex';
        if (variantInput) variantInput.style.borderRadius = '0px';
        if (emailInput) emailInput.style.borderRadius = '0px';
        if (label) label.style.fontSize = '12px';
        if (content) content.style.fontSize = '12px';
        if (title) {
          title.style.fontSize = '16px';
          title.style.fontWeight = '700';
          title.style.textTransform = 'uppercase';
        }
        if (closeButton) closeButton.style.fontSize = '18px';
        if (button) {
          button.style.textTransform = 'uppercase';
          button.style.fontSize = '11px';
          button.style.fontWeight = '700';
          button.style.borderRadius = '0px';
        }
        if (container) {
          container.style.borderRadius = '0px';
          container.style.padding = '20px 17px';
        }
      }, 1);
    });
  });
}
document.addEventListener('theme:variant:change', function (e) {
  var variant = e.detail.variant;
  var dummyBIS = document.querySelector('[data-klaviyo-bis-dummy]');
  var wrapper = document.querySelector('.klaviyo-wrapper');
  if (!variant || !dummyBIS || !wrapper) return;
  var isAvailable = variant.available;
  if (isAvailable) {
    dummyBIS.classList.add('tw-hidden');
  } else {
    dummyBIS.classList.remove('tw-hidden');
    var newTrigger = document.createElement('button');
    newTrigger.className = 'klaviyo-bis-trigger';
    newTrigger.setAttribute('data-variant-id', String(variant.id));
    newTrigger.style.display = 'none';
    document.body.appendChild(newTrigger);
    dummyBIS.addEventListener('click', function () {
      return newTrigger.click();
    }, {
      once: true
    });
    styleKlaviyoModalOnOpen();
  }
});
document.addEventListener('DOMContentLoaded', function () {
  styleKlaviyoModalOnOpen();
});

/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// - Ensure GDPR/CCPA compliance by providing legally required opt-in/opt-out functionality and transparency.
// - Refer to Shopify's privacy documentation for specific implementation requirements.
//
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
    this.logConsent = this.logConsent.bind(this);
  }
  // methods
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1'
              }], function (error) {
                if (error) {
                  console.error('Error loading features: ', error);
                  return;
                }
                console.log('Consent tracking API loaded');
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener('visitorConsentCollected', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate('update');
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById('recall-consent');
              if (recallConsentElement) {
                recallConsentElement.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
                analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                wait_for_update: 3000
              };
              this.gtag('consent', state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem('consentSettings', JSON.stringify(consent));
              this.logConsent(consent);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }() /* eslint-disable */)
  }, {
    key: "logConsent",
    value: (function () {
      var _logConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(consentSettings) {
        var _localStorage$getItem, userId, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              if (!((_localStorage$getItem = localStorage.getItem('userId')) !== null && _localStorage$getItem !== void 0)) {
                _context7.n = 1;
                break;
              }
              _t = _localStorage$getItem;
              _context7.n = 3;
              break;
            case 1:
              _context7.n = 2;
              return this.generateRandomHash();
            case 2:
              _t = _context7.v;
            case 3:
              userId = _t;
              localStorage.setItem('userId', userId);
              /* TODO: Add endpoint to log the users preferences for more compliance
                const logData = {
                user: USER_HERE,
                consentSettings,
                }
                       const response = await fetch('https://my-url/api/my-endpoint', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                });
                       if (!response.ok) {
                  throw new Error('Failed to log consent');
                }
                       const data = await response.json();
                console.log('Consent logged successfully: ', data);
                       COMMENT FOR ENDPOINT + DATABASE
                       When this event is recieved in the endpoint, the backend should first look at the website the request is coming from.
                If the request is coming from a website that is not allowed in our database, the request should be denied.
                This is to prevent unauthorized websites from logging consent settings, and to only allow websites that use our services to log consent settings.
                       After verifying the website, the backend should log the user's consent settings to a database
                If the user does not exist in the database, create a new entry for the user with the consent settings
                If the user exists in the database, update the user's consent settings with the new values
                       Database strucutre should be relational and could look like this:
                Each user / visitor belongs to a shop, and each shop can have multiple users / visitors
                Each user / visitor can have multiple consent settings
                       model: Shop
                       id | name | url | created_at | updated_at | user[]
                ---------------------------------------------------
                1  | Shop1| url1| 2021-09-01 | 2021-09-01 | [User1, User2, User3]
                       model: User
                       User | Functionality | Analytics | Personalization | Ad Storage | Ad User Data | Ad Personalization | created_at | updated_at | shop_id
                -------------------------------------------------------------------------------------------------------
                User1|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User2|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User3|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User4|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User5|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User6|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
              */
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t2 = _context7.v;
              console.error('Error logging consent: ', _t2);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 4]]);
      }));
      function logConsent(_x2) {
        return _logConsent.apply(this, arguments);
      }
      return logConsent;
    }())
  }, {
    key: "generateRandomHash",
    value: function () {
      var _generateRandomHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var randomHash;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              randomHash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              return _context8.a(2, randomHash);
          }
        }, _callee8);
      }));
      function generateRandomHash() {
        return _generateRandomHash.apply(this, arguments);
      }
      return generateRandomHash;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/AccountRegister.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AccountRegister.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AccountRegister)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Account Register
var AccountRegister = /*#__PURE__*/function () {
  function AccountRegister() {
    _classCallCheck(this, AccountRegister);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushAccountRegisterEvent = this.pushAccountRegisterEvent.bind(this);
    this.pushNewsLetterSubscribeEvent = this.pushNewsLetterSubscribeEvent.bind(this);
  }
  return _createClass(AccountRegister, [{
    key: "init",
    value: function init() {
      var _this = this;
      var accountRegisterForms = Array.from(document.querySelectorAll('form[action="/account"]'));
      if (accountRegisterForms.length >= 1) {
        accountRegisterForms.forEach(function (form) {
          form.addEventListener('submit', function () {
            _this.handleSubmit(form);
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var firstNameInput = form.querySelector('input[name="customer[first_name]"');
      var lastNameInput = form.querySelector('input[name="customer[last_name]"');
      var emailInput = form.querySelector('input[name="customer[email]"');
      var acceptsMarketingInput = form.querySelector('input[name="customer[accepts_marketing]"');
      var noteInputs = document.querySelectorAll('input[name^="customer[note]"]');
      var notes = [];
      var firstName = firstNameInput ? firstNameInput.value || '' : '';
      var lastName = lastNameInput ? lastNameInput.value || '' : '';
      var email = emailInput ? emailInput.value || '' : '';
      var acceptsMarketing = acceptsMarketingInput && acceptsMarketingInput.checked !== undefined ? acceptsMarketingInput.checked : false;
      if (noteInputs.length >= 1) {
        notes = Array.from(noteInputs).map(function (noteInput) {
          if (noteInput.value === '') return undefined;
          var noteFieldName = noteInput.name.split('customer[note]')[1] || '';
          noteFieldName = noteFieldName.replace('[', '').replace(']', '');
          return "".concat(noteFieldName, ": ").concat(noteInput.value);
        }).filter(function (note) {
          return note !== undefined;
        });
      }
      // Capturing the event in the accountRegisterEventObject
      var accountRegisterEventObject = {
        event: 'edition_account_register',
        signUpMethod: 'email',
        customerFirstName: firstName,
        customerLastName: lastName,
        customerEmail: email,
        acceptsMarketing: acceptsMarketing,
        customerNotes: notes
      };
      this.pushAccountRegisterEvent(accountRegisterEventObject);
      if (acceptsMarketing) {
        var newsLetterSubscribeEventObject = {
          event: 'edition_newsletter_subscribe',
          customerEmail: email
        };
        this.pushNewsLetterSubscribeEvent(newsLetterSubscribeEventObject);
      }
    }
  }, {
    key: "pushAccountRegisterEvent",
    value: function pushAccountRegisterEvent(accountRegisterEventObject) {
      this.dataLayer.push(accountRegisterEventObject);
    }
  }, {
    key: "pushNewsLetterSubscribeEvent",
    value: function pushNewsLetterSubscribeEvent(newsLetterSubscribeEventObject) {
      this.dataLayer.push(newsLetterSubscribeEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/AddToCart.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AddToCart.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AddToCart)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Datalayer Product Add to Cart
var AddToCart = /*#__PURE__*/function () {
  function AddToCart() {
    _classCallCheck(this, AddToCart);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.InterceptNetRequest = this.InterceptNetRequest.bind(this);
    this.pushProductAddToCartEvent = this.pushProductAddToCartEvent.bind(this);
  }
  return _createClass(AddToCart, [{
    key: "init",
    value: function init() {
      this.InterceptNetRequest();
    }
  }, {
    key: "InterceptNetRequest",
    value: function InterceptNetRequest() {
      var originalFetch = window.fetch.bind(window);
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      function _fetch() {
        _fetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, options) {
          var _this = this;
          var response, clone, data, _response, _clone, _data, addedItems;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(typeof url === 'string' && url.includes('cart/add'))) {
                  _context.n = 3;
                  break;
                }
                _context.n = 1;
                return originalFetch(url, options);
              case 1:
                response = _context.v;
                clone = response.clone();
                _context.n = 2;
                return clone.json();
              case 2:
                data = _context.v;
                this.pushProductAddToCartEvent(data);
                return _context.a(2, response);
              case 3:
                if (!(typeof url === 'string' && url.includes('cart/change'))) {
                  _context.n = 6;
                  break;
                }
                _context.n = 4;
                return originalFetch(url, options);
              case 4:
                _response = _context.v;
                _clone = _response.clone();
                _context.n = 5;
                return _clone.json();
              case 5:
                _data = _context.v;
                addedItems = _data.items_added || [];
                if (addedItems.length > 0) {
                  addedItems.forEach(function (item) {
                    var price = item.presentment_price * 100;
                    item.price = price;
                    _this.pushProductAddToCartEvent(item);
                  });
                }
                return _context.a(2, _response);
              case 6:
                return _context.a(2, originalFetch(url, options));
            }
          }, _callee, this);
        }));
        return _fetch.apply(this, arguments);
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "pushProductAddToCartEvent",
    value: function pushProductAddToCartEvent(data) {
      // if url contains collection
      var collectionHandle = window.location.href.includes('/collections/') ? window.location.href.split('/collections/')[1].split('/')[0] : '';
      // if product has only default variant, use product title as variant title
      var variantTitle = data.variant_title !== null ? data.variant_title : data.product_title;
      // clear the ecommerce object
      this.dataLayer.push({
        ecommerce: null
      });
      // Capture the event in the addToCartEventObject
      var addToCartEventObject = {
        event: 'edition_add_to_cart',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: data.price / 100 * data.quantity,
          items: [{
            item_name: data.product_title,
            item_id: data.product_id,
            item_brand: data.vendor,
            item_type: data.product_type,
            item_category: collectionHandle,
            item_variant: data.variant_id,
            item_variant_name: variantTitle,
            price: data.price / 100,
            item_sku: data.sku,
            quantity: data.quantity
          }]
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(addToCartEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/AddToWishlist.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AddToWishlist.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductAddToWishlist)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Add to Wishlist
// TODO

var ProductAddToWishlist = /*#__PURE__*/function () {
  function ProductAddToWishlist() {
    _classCallCheck(this, ProductAddToWishlist);
    _defineProperty(this, "addedToWishListEvent", 'Edition:AddedToWishlist');
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.listenForAddToWishlist = this.listenForAddToWishlist.bind(this);
  }
  return _createClass(ProductAddToWishlist, [{
    key: "init",
    value: function init() {
      this.listenForAddToWishlist();
    }
  }, {
    key: "listenForAddToWishlist",
    value: function listenForAddToWishlist() {
      var _this = this;
      document.addEventListener(this.addedToWishListEvent, function (event) {
        var details = event.detail;
        _this.pushAddToWishlistEvent(details);
      });
    }
  }, {
    key: "pushAddToWishlistEvent",
    value: function pushAddToWishlistEvent(details) {
      this.dataLayer.push({
        ecommerce: null
      });
      var addToWishlistEventObject = {
        event: 'edition_add_to_wishlist',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: 1,
          items: [{
            item_name: details.title,
            item_id: details.id,
            item_handle: details.handle,
            item_url: details.url
          }]
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(addToWishlistEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/CartView.ts":
/*!************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/CartView.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartView)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Datalayer Cart View
var CartView = /*#__PURE__*/function () {
  function CartView() {
    _classCallCheck(this, CartView);
    _defineProperty(this, "dataLayer", window.dataLayer);
    _defineProperty(this, "fetchUrl", "/cart.js");
    this.init = this.init.bind(this);
  }
  return _createClass(CartView, [{
    key: "init",
    value: function init() {
      if (window.location.href.includes('/cart')) {
        this.generateData();
      }
    }
  }, {
    key: "generateData",
    value: function generateData() {
      var _this = this;
      this.getCartData().then(function (data) {
        var itemsQty = data.item_count;
        var cartTotal = data.items_subtotal_price / 100;
        var items = data.items.map(function (item) {
          var variantTitle = item.variant_title !== null ? item.variant_title : item.product_title;
          return {
            item_name: item.product_title,
            item_id: item.product_id,
            item_brand: item.vendor,
            item_type: item.product_type,
            item_variant: item.variant_id,
            item_variant_name: variantTitle,
            price: item.price / 100,
            sku: item.sku,
            quantity: item.quantity
          };
        });
        _this.pushCartViewEvent(itemsQty, cartTotal, items);
      });
    }
  }, {
    key: "getCartData",
    value: function () {
      var _getCartData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var url, response, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              url = this.fetchUrl;
              _context.p = 1;
              _context.n = 2;
              return fetch(url);
            case 2:
              response = _context.v;
              if (!response.ok) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return response.json();
            case 3:
              data = _context.v;
              return _context.a(2, data);
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              throw new Error(_t);
            case 6:
              return _context.a(2, {});
          }
        }, _callee, this, [[1, 5]]);
      }));
      function getCartData() {
        return _getCartData.apply(this, arguments);
      }
      return getCartData;
    }()
  }, {
    key: "pushCartViewEvent",
    value: function pushCartViewEvent(itemsQty, cartTotal, items) {
      // clear the ecommerce object
      this.dataLayer.push({
        ecommerce: null
      });
      // Capturing the event in the cartViewEventObject
      var cartViewEventObject = {
        event: 'edition_cart_view',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: cartTotal,
          cart_quantity: itemsQty,
          items: items
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(cartViewEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/CollectionView.ts":
/*!******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/CollectionView.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CollectionView)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Datalayer Collection View
var CollectionView = /*#__PURE__*/function () {
  function CollectionView() {
    _classCallCheck(this, CollectionView);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.pushCollectionViewEvent = this.pushCollectionViewEvent.bind(this);
  }
  return _createClass(CollectionView, [{
    key: "init",
    value: function init() {
      if (window.editionCollectionData) {
        this.pushCollectionViewEvent();
      }
    }
  }, {
    key: "pushCollectionViewEvent",
    value: function () {
      var _pushCollectionViewEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var collectionData, collectionViewEventObject;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              collectionData = window.editionCollectionData;
              this.dataLayer.push({
                ecommerce: null
              });
              // Capturing the event in the collectionViewEventObject
              collectionViewEventObject = {
                event: 'edition_collection_view',
                ecommerce: {
                  currency: window.Shopify.currency.active,
                  item_list_name: collectionData.title,
                  item_list_id: collectionData.id,
                  item_list_products_count: collectionData.productsCount,
                  items: collectionData.products.map(function (product) {
                    return {
                      item_name: product.title,
                      item_id: product.id,
                      item_brand: product.vendor,
                      item_type: product.type,
                      item_category: collectionData.title,
                      item_variant: product.variants[0].id,
                      item_variant_name: product.variants[0].title,
                      price: product.variants[0].price / 100,
                      compare_at_price: (product.variants[0].compare_at_price || 0) / 100,
                      sku: product.variants[0].sku,
                      barcode: product.variants[0].barcode,
                      item_tags: product.tags,
                      item_created_at: product.created_at,
                      quantity: 1
                    };
                  })
                }
              };
              (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(collectionViewEventObject);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function pushCollectionViewEvent() {
        return _pushCollectionViewEvent.apply(this, arguments);
      }
      return pushCollectionViewEvent;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/ContactFormSubmit.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/ContactFormSubmit.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ContactFormSubmit)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Contact Form Submit
var ContactFormSubmit = /*#__PURE__*/function () {
  function ContactFormSubmit() {
    _classCallCheck(this, ContactFormSubmit);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushContactFormSubmitEventObject = this.pushContactFormSubmitEventObject.bind(this);
  }
  return _createClass(ContactFormSubmit, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get all contact forms that have more than one input field that is not hidden
      var contactForms = Array.from(document.querySelectorAll('form[action^="/contact"]')).filter(function (form) {
        return form.querySelectorAll('input:not([type="hidden"]), textarea').length > 1;
      });
      contactForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          _this.handleSubmit(form);
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var firstNameInput = form.querySelector('input[name="contact[Name]"');
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var phoneInput = form.querySelector('input[name="contact[Phone number]"]');
      var firstName = firstNameInput ? firstNameInput.value || '' : '';
      var email = emailInput ? emailInput.value || '' : '';
      var phone = phoneInput ? phoneInput.value || '' : '';
      // Capturing the event in the contactFormSubmitEventObject
      var contactFormSubmitEventObject = {
        event: 'edition_contact_form_submit',
        customerFirstName: firstName,
        customerEmail: email,
        customerPhone: phone
      };
      this.pushContactFormSubmitEventObject(contactFormSubmitEventObject);
    }
  }, {
    key: "pushContactFormSubmitEventObject",
    value: function pushContactFormSubmitEventObject(contactFormSubmitEventObject) {
      this.dataLayer.push(contactFormSubmitEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/ContextData.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/ContextData.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ContextData)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ContextData = /*#__PURE__*/function () {
  function ContextData() {
    _classCallCheck(this, ContextData);
    _defineProperty(this, "dataLayer", window.dataLayer);
    _defineProperty(this, "contextData", window.editionContextData);
    this.init = this.init.bind(this);
    this.pushContextData = this.pushContextData.bind(this);
  }
  return _createClass(ContextData, [{
    key: "init",
    value: function init() {
      this.pushContextData();
    }
  }, {
    key: "pushContextData",
    value: function pushContextData() {
      var contextDataObject = _objectSpread({
        event: 'contextData'
      }, this.contextData);
      console.log(contextDataObject, 'contextDataObject');
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(contextDataObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/DataLayer.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/DataLayer.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionDataLayer)
/* harmony export */ });
/* harmony import */ var _ContextData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ContextData */ "./resources/scripts/components/DataLayer/ContextData.ts");
/* harmony import */ var _UserData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UserData */ "./resources/scripts/components/DataLayer/UserData.ts");
/* harmony import */ var _DeviceData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DeviceData */ "./resources/scripts/components/DataLayer/DeviceData.ts");
/* harmony import */ var _ProductView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ProductView */ "./resources/scripts/components/DataLayer/ProductView.ts");
/* harmony import */ var _CollectionView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CollectionView */ "./resources/scripts/components/DataLayer/CollectionView.ts");
/* harmony import */ var _SelectCollectionItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SelectCollectionItem */ "./resources/scripts/components/DataLayer/SelectCollectionItem.ts");
/* harmony import */ var _CartView__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CartView */ "./resources/scripts/components/DataLayer/CartView.ts");
/* harmony import */ var _AddToCart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./AddToCart */ "./resources/scripts/components/DataLayer/AddToCart.ts");
/* harmony import */ var _Search__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Search */ "./resources/scripts/components/DataLayer/Search.ts");
/* harmony import */ var _Login__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Login */ "./resources/scripts/components/DataLayer/Login.ts");
/* harmony import */ var _AccountRegister__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AccountRegister */ "./resources/scripts/components/DataLayer/AccountRegister.ts");
/* harmony import */ var _ContactFormSubmit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./ContactFormSubmit */ "./resources/scripts/components/DataLayer/ContactFormSubmit.ts");
/* harmony import */ var _NewsletterSubscribe__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./NewsletterSubscribe */ "./resources/scripts/components/DataLayer/NewsletterSubscribe.ts");
/* harmony import */ var _RemoveFromCart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./RemoveFromCart */ "./resources/scripts/components/DataLayer/RemoveFromCart.ts");
/* harmony import */ var _AddToWishlist__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./AddToWishlist */ "./resources/scripts/components/DataLayer/AddToWishlist.ts");
/* harmony import */ var _MediaInteractions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./MediaInteractions */ "./resources/scripts/components/DataLayer/MediaInteractions.ts");
/* harmony import */ var _SessionDurationLogger__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./SessionDurationLogger */ "./resources/scripts/components/DataLayer/SessionDurationLogger.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

















var EditionDataLayer = /*#__PURE__*/function () {
  function EditionDataLayer() {
    _classCallCheck(this, EditionDataLayer);
    _defineProperty(this, "contextData", new _ContextData__WEBPACK_IMPORTED_MODULE_0__["default"]());
    _defineProperty(this, "userData", new _UserData__WEBPACK_IMPORTED_MODULE_1__["default"]());
    _defineProperty(this, "deviceData", new _DeviceData__WEBPACK_IMPORTED_MODULE_2__["default"]());
    _defineProperty(this, "productView", new _ProductView__WEBPACK_IMPORTED_MODULE_3__["default"]());
    _defineProperty(this, "collectionView", new _CollectionView__WEBPACK_IMPORTED_MODULE_4__["default"]());
    _defineProperty(this, "selectCollectionItem", new _SelectCollectionItem__WEBPACK_IMPORTED_MODULE_5__["default"]());
    _defineProperty(this, "cartView", new _CartView__WEBPACK_IMPORTED_MODULE_6__["default"]());
    _defineProperty(this, "addToCart", new _AddToCart__WEBPACK_IMPORTED_MODULE_7__["default"]());
    _defineProperty(this, "search", new _Search__WEBPACK_IMPORTED_MODULE_8__["default"]());
    _defineProperty(this, "login", new _Login__WEBPACK_IMPORTED_MODULE_9__["default"]());
    _defineProperty(this, "accountRegister", new _AccountRegister__WEBPACK_IMPORTED_MODULE_10__["default"]());
    _defineProperty(this, "contactFormSubmit", new _ContactFormSubmit__WEBPACK_IMPORTED_MODULE_11__["default"]());
    _defineProperty(this, "newsletterSubscribe", new _NewsletterSubscribe__WEBPACK_IMPORTED_MODULE_12__["default"]());
    _defineProperty(this, "removeFromCart", new _RemoveFromCart__WEBPACK_IMPORTED_MODULE_13__["default"]());
    _defineProperty(this, "addToWishlist", new _AddToWishlist__WEBPACK_IMPORTED_MODULE_14__["default"]());
    _defineProperty(this, "mediaInteractions", new _MediaInteractions__WEBPACK_IMPORTED_MODULE_15__["default"]());
    _defineProperty(this, "sessionDurationLogger", new _SessionDurationLogger__WEBPACK_IMPORTED_MODULE_16__["default"]());
    _defineProperty(this, "customDataLayerEnabled", window.customDataLayerEnabled || false);
    this.init = this.init.bind(this);
  }
  return _createClass(EditionDataLayer, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (this.customDataLayerEnabled) {
        /*
        TODO:
          Implement Shopifys analytics api for tracking standard events.
                 That means we need to deprecate the following events, and replace them with a customer pixel in Shopify backend
            - Cart viewed // TO DEPRECATE
            - Checkout Address Info Submitted
            - Checkout Completed
            - Checkout Contact Info Submitted
            - Checkout Shipping Info Submitted
            - Checkout Started
            - Collection viewed // TO DEPRECATE
            - Page viewed // TO DEPRECATE
            - Payment Info Submitted
            - Product added to cart // TO DEPRECATE
            - Product removed from cart // TO DEPRECATE
            - Product viewed // TO DEPRECATE
            - Search Submitted // TO DEPRECATE
         
               */
        setTimeout(function () {
          _this.contextData.init();
          _this.userData.init();
          _this.deviceData.init();
          _this.productView.init();
          _this.collectionView.init();
          _this.selectCollectionItem.init();
          _this.cartView.init();
          _this.addToCart.init();
          _this.search.init();
          _this.login.init();
          _this.accountRegister.init();
          _this.contactFormSubmit.init();
          _this.newsletterSubscribe.init();
          _this.removeFromCart.init();
          _this.addToWishlist.init();
          _this.mediaInteractions.init();
          _this.sessionDurationLogger.init();
        }, 1000);
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/DeviceData.ts":
/*!**************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/DeviceData.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ DeviceData)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var DeviceData = /*#__PURE__*/function () {
  function DeviceData() {
    _classCallCheck(this, DeviceData);
    _defineProperty(this, "dataLayer", window.dataLayer);
    _defineProperty(this, "deviceData", {
      colorDepth: window.screen.colorDepth,
      encoding: window.document.characterSet,
      language: window.navigator.language,
      screen: "".concat(window.screen.width, "x").concat(window.screen.height),
      viewport: "".concat(window.innerWidth, "x").concat(window.innerHeight),
      devicePixelRatio: window.devicePixelRatio,
      userAgent: window.navigator.userAgent,
      cookieEnabled: window.navigator.cookieEnabled,
      platform: window.navigator.platform,
      vendor: window.navigator.vendor,
      appVersion: window.navigator.appVersion,
      appName: window.navigator.appName,
      appCodeName: window.navigator.appCodeName
    });
    this.init = this.init.bind(this);
    this.pushDeviceData = this.pushDeviceData.bind(this);
  }
  return _createClass(DeviceData, [{
    key: "init",
    value: function init() {
      this.pushDeviceData();
    }
  }, {
    key: "pushDeviceData",
    value: function pushDeviceData() {
      var deviceDataObject = _objectSpread({
        event: 'deviceData'
      }, this.deviceData);
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(deviceDataObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/Login.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/DataLayer/Login.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Login)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Login
var Login = /*#__PURE__*/function () {
  function Login() {
    _classCallCheck(this, Login);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushLoginEvent = this.pushLoginEvent.bind(this);
  }
  return _createClass(Login, [{
    key: "init",
    value: function init() {
      var _this = this;
      var loginForms = Array.from(document.querySelectorAll('form[action="/account/login"]'));
      if (loginForms.length >= 1) {
        loginForms.forEach(function (form) {
          form.addEventListener('submit', function () {
            _this.handleSubmit(form);
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput.value || '';
      // Capturing the event in the loginEventObject
      var loginEventObject = {
        event: 'edition_login',
        loginMethod: 'email',
        customerEmail: email
      };
      this.pushLoginEvent(loginEventObject);
    }
  }, {
    key: "pushLoginEvent",
    value: function pushLoginEvent(loginEventObject) {
      this.dataLayer.push(loginEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/MediaInteractions.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/MediaInteractions.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MediaInteractions)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
// DataLayer Media Interactions
var MediaInteractions = /*#__PURE__*/function () {
  function MediaInteractions() {
    _classCallCheck(this, MediaInteractions);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.listenForMediaInteractions = this.listenForMediaInteractions.bind(this);
  }
  return _createClass(MediaInteractions, [{
    key: "init",
    value: function init() {
      var _this = this;
      setTimeout(function () {
        _this.listenForMediaInteractions();
      }, 1000);
    }
  }, {
    key: "listenForMediaInteractions",
    value: function listenForMediaInteractions() {
      var mediaElements = Array.from(document.querySelectorAll('video, audio'));
      mediaElements.forEach(function (mediaElement) {
        mediaElement.addEventListener('play', function (event) {
          /* console.log('Media Play Event', event); */
        });
        mediaElement.addEventListener('pause', function (event) {
          /* console.log('Media Pause Event', event); */
        });
        mediaElement.addEventListener('volumechange', function (event) {
          /* if (mediaElement.muted) {
            console.log('Media Mute Event', event);
          } */
        });
      });
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/NewsletterSubscribe.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/NewsletterSubscribe.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NewsletterSubscribe)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Newsletter Subscribe
var NewsletterSubscribe = /*#__PURE__*/function () {
  function NewsletterSubscribe() {
    _classCallCheck(this, NewsletterSubscribe);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushNewsletterSubscribeEventObject = this.pushNewsletterSubscribeEventObject.bind(this);
  }
  return _createClass(NewsletterSubscribe, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get all newsletter forms that only one input field that is not hidden
      var newsletterSubscribeForms = Array.from(document.querySelectorAll('form[action^="/contact"]')).filter(function (form) {
        return form.querySelectorAll('input:not([type="hidden"]), textarea').length === 1;
      });
      newsletterSubscribeForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          _this.handleSubmit(form);
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var email = emailInput ? emailInput.value || '' : '';
      // Capturing the event in the newsletterSubscribeEventObject
      var newsletterSubscribeEventObject = {
        event: 'edition_newsletter_subscribe',
        customerEmail: email
      };
      this.pushNewsletterSubscribeEventObject(newsletterSubscribeEventObject);
    }
  }, {
    key: "pushNewsletterSubscribeEventObject",
    value: function pushNewsletterSubscribeEventObject(newsletterSubscribeEventObject) {
      this.dataLayer.push(newsletterSubscribeEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/ProductView.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/ProductView.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductView)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Datalayer Product View
var ProductView = /*#__PURE__*/function () {
  function ProductView() {
    _classCallCheck(this, ProductView);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.pushProductViewEvent = this.pushProductViewEvent.bind(this);
  }
  return _createClass(ProductView, [{
    key: "init",
    value: function init() {
      if (window.location.href.includes('/products/')) {
        this.pushProductViewEvent();
      }
    }
  }, {
    key: "pushProductViewEvent",
    value: function () {
      var _pushProductViewEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var productData, urlParams, variantId, selectedVariant, collectionHandle, productViewEventObject;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              productData = window.editionProductData; // Check if the url has a variant query parameter. If it does, use that variant, otherwise use the first variant
              urlParams = new URLSearchParams(window.location.search);
              variantId = urlParams.get('variant');
              selectedVariant = variantId ? productData.variants.find(function (variant) {
                return variant.id === parseInt(variantId, 10);
              }) : productData.variants[0]; // if url contains collection
              collectionHandle = window.location.href.includes('/collections/') ? window.location.href.split('/collections/')[1].split('/')[0] : ''; // clear the ecommerce object
              this.dataLayer.push({
                ecommerce: null
              });
              // Capturing the event in the productViewEventObject
              productViewEventObject = {
                event: 'edition_view_item',
                ecommerce: {
                  currency: window.Shopify.currency.active,
                  value: selectedVariant.price / 100,
                  items: [{
                    item_name: productData.title,
                    item_id: productData.id,
                    item_brand: productData.vendor,
                    item_type: productData.type,
                    item_category: collectionHandle,
                    item_variant: selectedVariant.id,
                    item_variant_name: selectedVariant.title,
                    price: selectedVariant.price / 100,
                    compare_at_price: (selectedVariant.compare_at_price || 0) / 100,
                    sku: selectedVariant.sku,
                    barcode: selectedVariant.barcode,
                    item_tags: productData.tags,
                    item_created_at: productData.created_at,
                    quantity: 1
                  }]
                }
              };
              (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(productViewEventObject);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function pushProductViewEvent() {
        return _pushProductViewEvent.apply(this, arguments);
      }
      return pushProductViewEvent;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/RemoveFromCart.ts":
/*!******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/RemoveFromCart.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ RemoveFromCart)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// DataLayer Remove From Cart
var RemoveFromCart = /*#__PURE__*/function () {
  function RemoveFromCart() {
    _classCallCheck(this, RemoveFromCart);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.InterceptNetRequest = this.InterceptNetRequest.bind(this);
    this.pushRemoveFromCartEvent = this.pushRemoveFromCartEvent.bind(this);
  }
  return _createClass(RemoveFromCart, [{
    key: "init",
    value: function init() {
      this.InterceptNetRequest();
    }
  }, {
    key: "InterceptNetRequest",
    value: function InterceptNetRequest() {
      var originalFetch = window.fetch.bind(window);
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      function _fetch() {
        _fetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, options) {
          var _this = this;
          var response, clone, data, removedItems;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(typeof url === 'string' && url.includes('cart/change'))) {
                  _context.n = 3;
                  break;
                }
                _context.n = 1;
                return originalFetch(url, options);
              case 1:
                response = _context.v;
                clone = response.clone();
                _context.n = 2;
                return clone.json();
              case 2:
                data = _context.v;
                removedItems = data.items_removed || [];
                if (removedItems.length > 0) {
                  removedItems.forEach(function (item) {
                    _this.pushRemoveFromCartEvent(item);
                  });
                }
                return _context.a(2, response);
              case 3:
                return _context.a(2, originalFetch(url, options));
            }
          }, _callee);
        }));
        return _fetch.apply(this, arguments);
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "pushRemoveFromCartEvent",
    value: function pushRemoveFromCartEvent(data) {
      // clear the ecommerce object
      this.dataLayer.push({
        ecommerce: null
      });
      // Capture the event in the removeFromCartEventObject
      var removeFromCartEventObject = {
        event: 'edition_remove_from_cart',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: Number(data.price) * data.quantity,
          items: [{
            item_name: data.title,
            item_id: data.product_id,
            item_brand: data.vendor,
            item_type: data.product_type,
            item_variant: data.variant_id,
            price: Number(data.price),
            item_sku: data.sku,
            quantity: data.quantity
          }]
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(removeFromCartEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/Search.ts":
/*!**********************************************************!*\
  !*** ./resources/scripts/components/DataLayer/Search.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Search)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Search
var Search = /*#__PURE__*/function () {
  function Search() {
    _classCallCheck(this, Search);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
  }
  return _createClass(Search, [{
    key: "init",
    value: function init() {
      var _this = this;
      var searchForms = Array.from(document.querySelectorAll('form[action="/search"]'));
      searchForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          var searchInput = form.querySelector('input[type="search"]');
          var searchQuery = searchInput.value || '';
          // Capturing the event in the searchEventObject
          var searchEventObject = {
            event: 'edition_search',
            search_term: searchQuery
          };
          _this.pushSearchEvent(searchEventObject);
        });
      });
    }
  }, {
    key: "pushSearchEvent",
    value: function pushSearchEvent(searchEventObject) {
      this.dataLayer.push(searchEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/SelectCollectionItem.ts":
/*!************************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/SelectCollectionItem.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SelectCollectionItem)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Datalayer Select Collection Item
var SelectCollectionItem = /*#__PURE__*/function () {
  function SelectCollectionItem() {
    _classCallCheck(this, SelectCollectionItem);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.pushSelectCollectionItem = this.pushSelectCollectionItem.bind(this);
  }
  return _createClass(SelectCollectionItem, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (window.editionCollectionData) {
        var collectionProducts = window.editionCollectionData.products;
        var productHandles = collectionProducts.map(function (product) {
          return product.handle;
        });
        var productObjects = collectionProducts.map(function (product) {
          return {
            item_name: product.title,
            item_id: product.id,
            item_brand: product.vendor,
            item_type: product.type,
            item_category: window.editionCollectionData.title,
            item_variant: product.variants[0].id,
            item_variant_name: product.variants[0].title,
            price: product.variants[0].price,
            compare_at_price: (product.variants[0].compare_at_price || 0) / 100,
            sku: product.variants[0].sku,
            barcode: product.variants[0].barcode,
            item_tags: product.tags,
            item_created_at: product.created_at,
            quantity: 1,
            handle: product.handle
          };
        });
        var allAnchorTags = Array.from(document.querySelectorAll('a'));
        var productAnchorTags = allAnchorTags.filter(function (a) {
          return productHandles.some(function (productHandle) {
            return a.href.includes(productHandle);
          });
        });
        productAnchorTags.forEach(function (a) {
          a.addEventListener('click', function (event) {
            event.stopPropagation();
            event.preventDefault();
            event.stopImmediatePropagation();
            var location = a.href;
            // Find the index of the product by finding the index of the closest li element
            // Note this only works if the product grid is schemantic correct.
            var closestLi = a.closest('li');
            if (!closestLi) {
              return;
            }
            var index = Array.from(closestLi.parentElement.children).indexOf(closestLi);
            var selectedProduct = productObjects.find(function (product) {
              return a.href.includes(product.handle);
            });
            _this.pushSelectCollectionItem(selectedProduct, index, location);
          });
        });
      }
    }
  }, {
    key: "pushSelectCollectionItem",
    value: function pushSelectCollectionItem(selectedProduct, index, location) {
      var collectionData = window.editionCollectionData;
      this.dataLayer.push({
        ecommerce: null
      });
      // remove the handle from the product object
      delete selectedProduct.handle;
      // add the index of the product in the collection
      selectedProduct.index = index;
      // Capturing the event in the selectCollectionItemEventObject
      var selectCollectionItemEventObject = {
        event: 'edition_select_collection_item',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: selectedProduct.price / 100,
          item_list_name: collectionData.title,
          item_list_id: collectionData.id,
          item_list_products_count: collectionData.productsCount,
          items: [selectedProduct]
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(selectCollectionItemEventObject);
      setTimeout(function () {
        window.location.href = location;
      }, 100);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/SessionDurationLogger.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/SessionDurationLogger.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SessionDurationLogger)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Import pushToDataLayer helper function (as in your example)

// Define the custom web component class
var SessionDurationLogger = /*#__PURE__*/function () {
  function SessionDurationLogger() {
    _classCallCheck(this, SessionDurationLogger);
    _defineProperty(this, "maxTime", 300);
    _defineProperty(this, "logInterval", 30);
    _defineProperty(this, "lastLoggedTime", 0);
    _defineProperty(this, "intervalID", null);
    this.init = this.init.bind(this);
    this.startLogging = this.startLogging.bind(this);
    this.logElapsedTime = this.logElapsedTime.bind(this);
  }
  // Store the session start time if not already stored
  return _createClass(SessionDurationLogger, [{
    key: "init",
    value: function init() {
      if (!sessionStorage.getItem('gtm_session_start')) {
        sessionStorage.setItem('gtm_session_start', Date.now().toString());
      }
      this.startLogging();
    }
    // Function to start the interval timer for logging session duration
  }, {
    key: "startLogging",
    value: function startLogging() {
      var _this = this;
      this.intervalID = setInterval(function () {
        return _this.logElapsedTime();
      }, 1000); // Keep this if logging every second is needed
    }
    // Function to check elapsed time and log it if needed
  }, {
    key: "logElapsedTime",
    value: function logElapsedTime() {
      var startTime = parseInt(sessionStorage.getItem('gtm_session_start'), 10) || Date.now();
      var currentTime = Date.now();
      var elapsedTime = currentTime - startTime;
      var elapsedSeconds = Math.floor(elapsedTime / 1000);
      if (elapsedSeconds % this.logInterval === 0 && elapsedSeconds !== this.lastLoggedTime && elapsedSeconds <= this.maxTime) {
        // Prepare the dataLayer event object
        var eventObject = {
          event: 'engaged_session',
          session_duration: elapsedSeconds
        };
        // Push the event to the dataLayer
        (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(eventObject);
        // Update the last logged time
        this.lastLoggedTime = elapsedSeconds;
      }
      // Stop logging if the maximum time has been reached
      if (elapsedSeconds > this.maxTime) {
        clearInterval(this.intervalID);
        this.intervalID = null; // Reset to avoid stale references
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/UserData.ts":
/*!************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/UserData.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ UserData)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var UserData = /*#__PURE__*/function () {
  function UserData() {
    _classCallCheck(this, UserData);
    _defineProperty(this, "dataLayer", window.dataLayer);
    _defineProperty(this, "userData", window.editionUserData);
    _defineProperty(this, "hash", void 0);
    this.init = this.init.bind(this);
    this.pushUserData = this.pushUserData.bind(this);
  }
  return _createClass(UserData, [{
    key: "init",
    value: function init() {
      this.pushUserData();
    }
  }, {
    key: "sha256",
    value: function () {
      var _sha = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(str) {
        var buffer, hashBuffer, hashArray, hashHex, hashGroups;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (str) {
                _context.n = 1;
                break;
              }
              return _context.a(2, '');
            case 1:
              buffer = new TextEncoder().encode(str);
              _context.n = 2;
              return crypto.subtle.digest('SHA-256', buffer);
            case 2:
              hashBuffer = _context.v;
              hashArray = Array.from(new Uint8Array(hashBuffer));
              hashHex = hashArray.map(function (_byte) {
                return _byte.toString(16).padStart(2, '0');
              }).join(''); // split the hashHex every 8 characters and join with a hyphen
              hashGroups = hashHex.match(/.{1,8}/g).join('-');
              this.hash = hashGroups;
              return _context.a(2, hashGroups);
          }
        }, _callee, this);
      }));
      function sha256(_x) {
        return _sha.apply(this, arguments);
      }
      return sha256;
    }()
  }, {
    key: "pushUserData",
    value: function () {
      var _pushUserData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var userId, hashedDataEmail, hashedFirstName, hashedLastName, hashedPhoneNumber, userDataObject, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.sha256(this.userData.email);
            case 1:
              hashedDataEmail = _context2.v;
              _context2.n = 2;
              return this.sha256(this.userData.firstName);
            case 2:
              hashedFirstName = _context2.v;
              _context2.n = 3;
              return this.sha256(this.userData.lastName);
            case 3:
              hashedLastName = _context2.v;
              _context2.n = 4;
              return this.sha256(this.userData.phone);
            case 4:
              hashedPhoneNumber = _context2.v;
              if (!(hashedDataEmail !== '')) {
                _context2.n = 5;
                break;
              }
              userId = hashedDataEmail;
              _context2.n = 8;
              break;
            case 5:
              _t = localStorage.getItem('userId');
              if (_t) {
                _context2.n = 7;
                break;
              }
              _context2.n = 6;
              return this.generateRandomHash();
            case 6:
              _t = _context2.v;
            case 7:
              userId = _t;
              localStorage.setItem('userId', userId);
            case 8:
              this.userData.user_id = userId;
              this.userData.hashed_email = hashedDataEmail;
              this.userData.hashed_first_name = hashedFirstName;
              this.userData.hashed_last_name = hashedLastName;
              this.userData.hashed_phone_number = hashedPhoneNumber;
              userDataObject = {
                event: 'userData',
                customer: this.userData
              };
              (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(userDataObject);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function pushUserData() {
        return _pushUserData.apply(this, arguments);
      }
      return pushUserData;
    }()
  }, {
    key: "generateRandomHash",
    value: function () {
      var _generateRandomHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var randomHash;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.sha256(Math.random().toString());
            case 1:
              randomHash = _context3.v;
              return _context3.a(2, randomHash);
          }
        }, _callee3, this);
      }));
      function generateRandomHash() {
        return _generateRandomHash.apply(this, arguments);
      }
      return generateRandomHash;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/GeoPopout/GeoPopout.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/GeoPopout/GeoPopout.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GeoPopout)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var GeoPopout = /*#__PURE__*/function (_HTMLElement) {
  function GeoPopout() {
    var _this;
    _classCallCheck(this, GeoPopout);
    _this = _callSuper(this, GeoPopout);
    _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
    return _this;
  }
  _inherits(GeoPopout, _HTMLElement);
  return _createClass(GeoPopout, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var dismissed, closeBtn, visitorCode;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              dismissed = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('geopopout-dismissed');
              if (!(dismissed === 'true')) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.addEventListener('click', this.handleOverlayClick);
              closeBtn = this.querySelector('#geopopout-close');
              if (closeBtn) {
                closeBtn.addEventListener('click', function () {
                  _this2.hide();
                });
              }
              if (!(Shopify.designMode === true)) {
                _context.n = 2;
                break;
              }
              this.show();
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.getVisitorCountryCode();
            case 3:
              visitorCode = _context.v;
              if (visitorCode) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              if (this.showIfCode(visitorCode)) {
                this.show();
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "getVisitorCountryCode",
    value: function () {
      var _getVisitorCountryCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _data$detected_values;
        var response, data, handle, code;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/browsing_context_suggestions.json');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              handle = data === null || data === void 0 || (_data$detected_values = data.detected_values) === null || _data$detected_values === void 0 || (_data$detected_values = _data$detected_values.country) === null || _data$detected_values === void 0 ? void 0 : _data$detected_values.handle;
              if (handle) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, null);
            case 3:
              code = handle.toUpperCase();
              this.setAttribute('data-visitor-country', code);
              return _context2.a(2, code);
          }
        }, _callee2, this);
      }));
      function getVisitorCountryCode() {
        return _getVisitorCountryCode.apply(this, arguments);
      }
      return getVisitorCountryCode;
    }()
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;
      this.classList.remove('tw-z-[-1]');
      this.classList.add('tw-z-[100]');
      setTimeout(function () {
        _this3.classList.add('!tw-opacity-100');
      }, 500);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this4 = this;
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('geopopout-dismissed', 'true', 60 * 24 * 7);
      this.classList.remove('tw-opacity-100');
      this.classList.add('tw-opacity-0');
      setTimeout(function () {
        _this4.remove();
      }, 500);
    }
  }, {
    key: "handleOverlayClick",
    value: function handleOverlayClick(event) {
      if (event.target === this) {
        this.hide();
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "showIfCode",
    value: function showIfCode(code) {
      var showCodes = new Set(['US', 'AU', 'NZ', 'CH', 'GB']);
      return showCodes.has(code);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deleteCookie: () => (/* binding */ deleteCookie),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/scripts/utils/DatalayerHelpers.ts":
/*!*****************************************************!*\
  !*** ./resources/scripts/utils/DatalayerHelpers.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ pushToDataLayer)
/* harmony export */ });
window.dataLayer = window.dataLayer || [];
// Function to push the event to the datalayer.
// If something goes wrong and the event does not get pushed, we check again after a set interval and try to push again.
function pushToDataLayer(object) {
  window.dataLayer.push(object);
  var intervalId = setInterval(function () {
    var isEventPushed = window.dataLayer.includes(object);
    if (!isEventPushed) {
      window.dataLayer.push(object);
    } else {
      clearInterval(intervalId);
    }
  }, 750);
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/src/assets/app": 0,
/******/ 			"src/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkd8f0d1_2"] = self["webpackChunkd8f0d1_2"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;